import { useContext, useEffect } from 'react';

import type { ExperienceAttributes } from '../ExperienceEvent.ts';

import { ExperienceTrackerContext } from './ExperienceTrackerContext.tsx';

export type ExperienceFailureProps = {
	name: string;
	error: Error;
	attributes?: ExperienceAttributes;
};

export function ExperienceFailure({ name, error, attributes }: ExperienceFailureProps) {
	const experienceTracker = useContext(ExperienceTrackerContext);

	useEffect(
		() => experienceTracker.fail({ name, error, attributes }),
		[experienceTracker, name, error, attributes],
	);

	return null;
}
